export const CSRF_CONFIG = {
  HEADER_NAME: "x-csrf-token",
  META_NAME: "csrf-token",
} as const;
